<template>
  <div>
    <b-list-group-item
      button
      v-for="(item, index) in get_volunteer_by_location"
      :key="'item -' + index"
      :item="item"
      class="bg-fff shadow-lg p-4 mb-4 border"
    >
      <div>
        <div class="bg-white border" @click="handleView(item)">
          <div class="flex gap-4">
            <img
              :src="
                item.profile
                  ? $imageURL + '/' + item.profile
                  : require('@/assets/images/blank-profile.png')
              "
              :alt="item.firstname"
              ref="cover"
              class="w-1/4 object-cover"
            />

            <div class="w-3/4 profile-main lg:py-2 md:py-2 py-2">
              <h1 class="fsize16 capitalize line-height-30px">
                <b> {{ item.userId.firstname }} {{ item.userId.lastname }}</b>
              </h1>
              <p class="fsize14">{{ item.location }}</p>
              <h3 class="font-semibold lg:mt-1 md:mt-1 fsize12">
                +91 {{ item.userId.mobile }}
              </h3>
              <h3 class="sm-fsize14">{{ item.expertise }}</h3>
              <div class="flex pt-2">
                <h1
                  class="fsize14 font-semibold flex items-center justify-start w-full"
                >
                  Rs. {{ item.price }} /hr
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-list-group-item>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    async handleView(item) {
      await this.$store.dispatch("respitecare/get_volunteerbyid", {
        volunteerId: item._id,
      });
      await this.$store.dispatch("respitecare/get_allreview", {
        volunteerId: item._id,
      });
    },
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
    ...mapState("respitecare", {
      getVolunteerByService: "getVolunteerByService",
      serviceDiscount: "serviceDiscount",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
};
</script>

<style>
.list-group-item {
  background-color: #f8f9fe;
  border: none;
}
.list-group-item {
  padding: 0rem !important;
}
</style>
